<template>
    <div class="bot-chat">
        <div class="bot-chat--wrapper">
            <div>
                <div class="bot-chat--item">
                    <common-icon class="bot-chat--item__icon" name="chat-bot" size="gigantic"></common-icon>
                    <div class="bot-chat--item__message">{{ defaultMessage }}</div>
                </div>
            </div>
            <div v-for="(element, index) in messageList" :key="index">
                <div v-if="element.isEdha" class="bot-chat--item">
                    <common-icon class="bot-chat--item__icon" name="chat-bot" size="gigantic"></common-icon>
                    <div v-if="element.message?.length" class="bot-chat--item__message">
                        <p v-for="(msg, i) in element.message" :key="i" class="bot-chat--item__message--row">
                            {{ msg }}
                        </p>
                    </div>
                    <div v-else class="bot-chat--item__loader">
                        <common-loader :isProcessing="isSending"></common-loader>
                    </div>
                </div>
                <div v-else class="bot-chat--item bot-chat--item--user">
                    <common-user-avatar :user="$auth.getActiveMember()" size="user-menu"></common-user-avatar>
                    <div class="bot-chat--item__message">
                        <p v-for="(msg, i) in element.message" :key="i">
                            {{ msg }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="bot-chat--item bot-chat--item__questions">
                <common-button
                    v-for="(el, index) in questionTypes"
                    :key="index"
                    :isDisabled="isSending"
                    :class="{ 'button--active': index === activeQuestionIndex }"
                    :label="el.header"
                    type="secondary"
                    size="medium"
                    @click="setActiveQuestionType(index)"
                ></common-button>
            </div>
            <form-wrapper class="bot-chat--footer">
                <form-row>
                    <form-cell>
                        <text-field
                            :isDisabled="activeQuestionIndex === null || isSending"
                            valuePath="question"
                            :formData="data"
                            :placeholder="getQuestionPlaceholder"
                            :isRequired="true"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>

                <template #footer>
                    <common-buttons>
                        <common-button
                            :isDisabled="!data.question || activeQuestionIndex === null"
                            :isProcessing="isSending"
                            :isSubmittable="true"
                            :label="$t('common.microcopy.send')"
                            type="tertiary"
                            size="medium"
                            @click="sendMessage()"
                        ></common-button>
                    </common-buttons>
                </template>
            </form-wrapper>
        </div>
    </div>
</template>

<script>
    import ChatGptApi from 'api/ChatGptApi'
    import FormMixin from 'mixins/FormMixin'

    export default {
        mixins: [FormMixin],
        components: {},

        data() {
            return {
                messageList: [],
                messageHistory: [],
                isSending: false,
                activeQuestionIndex: null,
                headerIndex: 0,
                messageListAnswerIndex: 0,
                defaultMessage: this.$t('pages.assistant.virtual_assistant.edha_chat.default'),
                questionTypes: [
                    {
                        header: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.header_1'),
                        chatGptQuestion: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.chatGptQuestion_1'),
                        question: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.question_1'),
                        placeholder: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.placeholder_1'),
                        context: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.context_1'),
                    },
                    {
                        header: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.header_2'),
                        chatGptQuestion: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.chatGptQuestion_2'),
                        question: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.question_2'),
                        placeholder: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.placeholder_2'),
                        context: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.context_2'),
                    },
                    {
                        header: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.header_3'),
                        chatGptQuestion: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.chatGptQuestion_3'),
                        question: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.question_3'),
                        placeholder: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.placeholder_3'),
                        context: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.context_3'),
                    },
                    {
                        header: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.header_4'),
                        chatGptQuestion: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.chatGptQuestion_4'),
                        question: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.question_4'),
                        placeholder: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.placeholder_4'),
                        context: this.$t('pages.assistant.virtual_assistant.edha_chat.question_types.context_4'),
                    },
                ],
            }
        },

        computed: {
            getQuestionPlaceholder() {
                if (this.activeQuestionIndex || this.activeQuestionIndex === 0) {
                    return this.questionTypes[this.activeQuestionIndex].placeholder
                }
                return this.$t('pages.assistant.virtual_assistant.enter_question')
            },
        },

        methods: {
            sendMessage() {
                const context = this.questionTypes[this.activeQuestionIndex].context

                this.isSending = true
                this.messageList.push({
                    message: [this.data.question],
                    isEdha: false,
                })
                this.messageList.push({
                    message: [],
                    isEdha: true,
                })
                this.addToMessageHistory(this.data.question, 'user')
                this.data.question = ''
                this.scrollToChatEnd()

                ChatGptApi.getGptResponse(this.messageHistory, context)
                    .then((response) => {
                        this.messageListAnswer = response.text.split('\n')
                        this.typeEffect(this.messageListAnswer)
                        this.addToMessageHistory(response.text, 'assistant')
                    })
                    .catch(() => {
                        this.messageListAnswer = [this.$t('pages.errors.general_error.title')]
                        this.typeEffect(this.messageListAnswer)
                    })
            },

            typeEffect() {
                this.messageListAnswerIndex = 0
                if (this.messageListAnswer.length) {
                    if (this.messageList[this.messageList.length - 1].message.length === this.messageListAnswerIndex) {
                        this.messageList[this.messageList.length - 1].message.push('')
                    }
                    this.addMessage(this.messageListAnswer[this.messageListAnswerIndex], this.messageListAnswerIndex)
                }
            },

            addMessage(msg, i) {
                const speed = 10

                if (this.headerIndex < msg?.length) {
                    this.$set(
                        this.messageList[this.messageList.length - 1].message,
                        i,
                        this.messageList[this.messageList.length - 1].message[i] + msg.charAt(this.headerIndex),
                    )
                    this.headerIndex = this.headerIndex + 1
                    this.scrollToChatEnd()
                    setTimeout(() => {
                        this.addMessage(msg, i)
                    }, speed)
                } else if (i + 1 < this.messageListAnswer.length) {
                    this.messageList[this.messageList.length - 1].message.push('')
                    this.messageListAnswerIndex = this.messageListAnswerIndex + 1
                    this.headerIndex = 0
                    this.addMessage(this.messageListAnswer[this.messageListAnswerIndex], this.messageListAnswerIndex)
                } else {
                    this.isSending = false
                    this.headerIndex = 0
                }
            },

            setActiveQuestionType(index) {
                this.activeQuestionIndex = index

                const message = {
                    message: [this.questionTypes[index].question],
                    isEdha: true,
                }
                this.messageList.push(message)
                this.scrollToChatEnd()
            },

            scrollToChatEnd() {
                const el = document.getElementsByClassName('bot-chat--wrapper')[0]
                setTimeout(() => {
                    if (el) {
                        el.scrollTop = el.scrollHeight
                    }
                }, 0)
            },

            addToMessageHistory(message, role) {
                this.messageHistory.push({
                    content: message,
                    role,
                })
            },
        },
    }
</script>
